import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { environment } from "src/environments/environment";
import { EUserRole } from "../domain/enum/user-role";
import { ENavigationRoute } from "../model/enum/navigation-route";
import { CoreData } from "./core-data/core-data";

@Injectable()
export class ConfigurationGuard implements CanActivate {
  constructor(
    private router: Router,
    private coreData: CoreData) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    /*if (environment.name === 'DEV') {
      return true;
    }
    if (route.routeConfig?.path === ENavigationRoute.Config && this.coreData.IsLoggedIn && this.coreData.User?.Type === EUserRole.Gestionnaire) {
      return true;
    }
    if (route.routeConfig?.path === ENavigationRoute.News && this.coreData.IsLoggedIn) {
      return true;
    }*/
    const pwd = window.prompt('Mot de passe');
    return pwd === 'ymWUxgx%hqY&B~K'  ? true : this.router.parseUrl(ENavigationRoute.Error);
  }
}